// tslint:disable-next-line:max-line-length
import { CrossTherapyArticleLineViewModel } from 'src/app/business/cross-therapy/cross-therapy-article-line-view-model';
// tslint:disable-next-line:max-line-length
export class GrossPriceCalculator {
  public static updateSinglePrice(quantity: number, total: string, packagingUnitQuantity?: number): string {
    let singlePrice = 0;
    singlePrice =
      parseFloat(total.replace(/,/g, '.')) / (quantity * (packagingUnitQuantity ? packagingUnitQuantity : 1));
    return singlePrice.toFixed(2).toString().replace(/\./g, ',');
  }

  // Zwischensumme brutto
  public static calculateArticleLinesSubTotal(articleLines: CrossTherapyArticleLineViewModel[]) {
    let total = 0;
    articleLines?.forEach(orderedArticle => {
      if (orderedArticle.totalPrice) {
        total += parseFloat(orderedArticle.totalPrice.replace(/,/g, '.'));
      } else if (orderedArticle.price) {
        total +=
          orderedArticle.quantity *
          ((orderedArticle.packagingUnitQuantity ? orderedArticle.packagingUnitQuantity : 1) *
            parseFloat(orderedArticle.price.replace(/,/g, '.')));
      }
    });
    return total.toFixed(2).toString().replace(/\./g, ',');
  }
  // Gesamt (Netto + Versandkosten netto)
  public static calculateArticleLinesWithShippingNet(articleTotalWithShipping: string, vatRate: string) {
    const articlesTotal = parseFloat(articleTotalWithShipping.replace(/,/g, '.'));
    const vat = (100 + parseFloat(vatRate.replace(/,/g, '.'))) / 100;
    return (articlesTotal / vat).toFixed(2).toString().replace(/\./g, ',');
  }
  // MWST Betrag herausgerechnet aus Bruttogesamtsumme
  public static calculateArticleLinesVatAmount(articleTotalGross: string, articleTotalNet: string) {
    return (parseFloat(articleTotalGross.replace(/,/g, '.')) - parseFloat(articleTotalNet.replace(/,/g, '.')))
      .toFixed(2)
      .toString()
      .replace(/\./g, ',');
  }

  // Gesamtpreis brutto
  public static calculateArticleLinesGrossTotal(articleTotalGross: string, shipping: string) {
    const total = parseFloat(articleTotalGross.replace(/,/g, '.')) + parseFloat(shipping.replace(/,/g, '.'));
    return total.toFixed(2).toString().replace(/\./g, ',');
  }
}
